/**
 * Negocio de Sinapsis usado internamente para pruebas.
 * En este tenant se exponen ambas modalidades de mantenimiento.
 */
export const SINAPSIS_TEST_BUSINESS_ID = 'b52a5c5d-8a05-41d9-adea-19bc5b88d4e1';

/** Dominio del negocio de pruebas Sinapsis. */
export const SINAPSIS_TEST_BUSINESS_DOMAIN = 'sinapsis-prod';

/**
 * @description
 * Indica si el negocio activo es el de pruebas de Sinapsis.
 * @param {{ id?: string; domain?: string } | null | undefined} business Negocio actual.
 * @returns {boolean}
 */
export function isSinapsisTestBusiness(
  business: { id?: string; domain?: string } | null | undefined,
): boolean {
  if (!business) {
    return false;
  }

  return (
    business.id === SINAPSIS_TEST_BUSINESS_ID ||
    business.domain === SINAPSIS_TEST_BUSINESS_DOMAIN
  );
}
